import React, { Component } from "react";
// import LogoFull from "components/Logo/LogoFull";
// import CategoryItens from "components/Filter/CategoryItens/CategoryItens";
import Search from "components/Search/Search";
import Menu from "components/MenuBottom/MenuBottom";
import styles from "./SideBar.module.scss";
import LogoSmall from "components/Logo/LogoSmall";
import CategoryCarousel from "components/Filter/CategoryCarousel/CategoryCarousel";
import BoxFilter from "components/BoxFilter/BoxFilter";

export default class Main extends Component {
    render() {
        return (
            <div className={styles.home}>
                <div className={styles.carousel}>
                    <LogoSmall />
                    <div className={styles.sidebar}>
                        <Search
                            filtrar={this.props.filtrar}
                            selectedMkr={this.props.selectedMkr}
                            setSelectedMkr={this.props.setSelectedMkr}
                            categorias={this.props.categorias}
                            setZoom={this.props.setZoom}
                            setIsSeenOnMap={this.props.setIsSeenOnMap}
                            setFilterText={this.props.setFilterText}
                            filterText={this.props.filterText}
                        />
                        <CategoryCarousel
                            filtrar={this.props.filtrar}
                            selectedMkr={this.props.selectedMkr}
                            setSelectedMkr={this.props.setSelectedMkr}
                            categorias={this.props.categorias}
                            setIsSeenOnMap={this.props.setIsSeenOnMap}
                            setZoom={this.props.setZoom}
                            setFilterText={this.props.setFilterText}
                        />
                    </div>
                </div>
                <BoxFilter
                    selectedMkr={this.props.selectedMkr}
                    favoritar={this.props.favoritar}
                    estabelecimentosFavoritos={
                        this.props.estabelecimentosFavoritos
                    }
                    estabelecimentos={this.props.estabelecimentos}
                    userLocation={this.props.userLocation}
                    setSelectedEstabelecimento={
                        this.props.setSelectedEstabelecimento
                    }
                    setZoom={this.props.setZoom}
                />
                <div className={styles.menu}>
                    <Menu
                        estabelecimentosFavoritos={
                            this.props.estabelecimentosFavoritos
                        }
                        selectedMkr={this.props.selectedMkr}
                        estabelecimentos={this.props.estabelecimentos}
                        userLocation={this.props.userLocation}
                        setSelectedEstabelecimento={
                            this.props.setSelectedEstabelecimento
                        }
                        favoritar={this.props.favoritar}
                    />
                </div>
            </div>
        );
    }
}
